import { Controller } from '@hotwired/stimulus';
import CropperCanvas from '@cropper/element-canvas';
import CropperImage from '@cropper/element-image';
import CropperSelection from '@cropper/element-selection';
import CropperHandle from '@cropper/element-handle';

CropperCanvas.$define();
CropperImage.$define();
CropperSelection.$define();
CropperHandle.$define();

export default class extends Controller {
  static targets = ['input', 'modal', 'canvas', 'image', 'selection', 'cropButton', 'preview'];

  connect() {
    console.log("cropper connected")
    this.cropperCanvas = this.canvasTarget;
    this.cropperImage = this.imageTarget;
    this.cropperSelection = this.selectionTarget;
  }

  openModal(event) {
    event.preventDefault();
    this.modalTarget.classList.remove('hidden');
    this.loadImage();
  }



  loadImage(event) {
    const file = this.inputTarget.files[0];
    console.log("files", file, this.inputTarget.files)
    const reader = new FileReader();

    reader.onload = (e) => {
      this.imageTarget.src = e.target.result;
      this.initializeCropper();
      
    };

    reader.readAsDataURL(file);
  }


  initializeCropper() {
    const image = this.imageTarget;
    image.$ready().then((img) => {
    
      image.$center('contain').$zoom(-0.1);
    });
    const selection_size = 300

    const selection = this.canvasTarget.querySelector('cropper-selection');
    selection.width = selection_size;
    selection.height = selection_size;
    selection.x = (this.canvasTarget.clientWidth - selection_size) / 2;
    selection.y = (this.canvasTarget.clientHeight - selection_size) / 2;
    selection.$render();
  }

  async cropImage() {
    const canvas = await this.cropperSelection.$toCanvas({ width: 300, height: 300 });

    canvas.toBlob((blob) => {
      const file = new File([blob], 'cropped_profile_image.png', { type: 'image/png' });
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      this.inputTarget.files = dataTransfer.files;
      this.previewTarget.src = URL.createObjectURL(blob);
    });

    this.modalTarget.classList.add('hidden');
  }

  closeModal() {
    this.modalTarget.classList.add('hidden');
  }
}
